import {occurrencePosition, calendarDateAtInstant, readDeviceDisplayContext} from '@liquid-spirit/date-time/display';

// Legacy activity-level requests target the next active session. Keep this
// choice consistent across the supported web and mobile callers.
export function nextActivitySession(activity, now = new Date(), display = readDeviceDisplayContext()) {
  display = {...readDeviceDisplayContext(), ...display};
  const sessions = Array.isArray(activity?.sessions) ? activity.sessions : [];
  if (sessions.some(session => session?.timingVersion !== undefined)) {
    const instant = new Date(now).toISOString();
    return sessions.flatMap(session => {
      if (!session || !['Pending', 'Scheduled', 'Confirmed'].includes(session.status)) return [];
      if (session.timingVersion !== undefined) {
        try {
          const position = occurrencePosition(session, display, instant);
          return position.upcoming ? [{session, key: position.sortKey}] : [];
        } catch { return []; }
      }
      const date = new Date(session.date);
      const today = new Date(now); today.setUTCHours(0, 0, 0, 0);
      if (!Number.isFinite(date.getTime()) || date < today) return [];
      return [{session, key: `${calendarDateAtInstant(date.toISOString(), display.timeZone)}:1:${date.toISOString()}`}];
    }).sort((a,b) => a.key.localeCompare(b.key) || String(a.session._id).localeCompare(String(b.session._id)))[0]?.session || null;
  }
  const today = new Date(now);
  today.setUTCHours(0, 0, 0, 0);
  return sessions.filter(session => session && typeof session === 'object'
    && ['Pending', 'Scheduled', 'Confirmed'].includes(session.status)
    && Date.parse(session.date) >= today.getTime())
    .sort((a, b) => Date.parse(a.date) - Date.parse(b.date) || a._id.localeCompare(b._id))[0] || null;
}
